/**
 * Trigger label for a checkbox multi-select: `allLabel` when empty, the joined
 * labels for one or two, else "N selected".
 *
 * `fewLabels` is only read when `count <= 2`, so callers can skip resolving
 * labels for larger sets.
 *
 * Lives in the package because BOTH the shared `Picker` and the app's
 * multi-select widgets summarise a selection the same way — and because a
 * trigger that spelled out forty labels instead of counting them is unreadable
 * to a screen reader, which is exactly what an unsummarised name did.
 */
export function summarizeSelection(count: number, fewLabels: string[], allLabel: string): string {
  if (count === 0) return allLabel;
  if (count <= 2) return fewLabels.join(', ');
  return `${count} selected`;
}
